<template>
  <div class="flex items-center min-h-screen">
    <div class="w-full max-w-md mx-auto text-center">
      <a
        target="_blank"
        href="https://moment-juke.de"
      >
        <mj-icon
          src="moment-juke-logo"
          class="w-40 h-auto mb-8 transition-slower transition-transform"
          :class="{ 'rotate-720' : isBusy}"
        />
      </a>
      <mj-card>
        <h2 class="text-2xl font-semibold text-left">
          Hey, schön dich wieder zu sehen!
        </h2>
        <mj-validation-observer
          id="login"
          ref="formObserver"
          tag="form"
          method="post"
          @submit.prevent="onLogin"
        >
          <mj-input-group>
            <mj-input-label for="mail">
              E-Mail
            </mj-input-label>
            <mj-validation-input-field
              v-model="form.email"
              name="email"
              rules="required|email"
              autofocus
              type="email"
              @focus="clearError"
            />
          </mj-input-group>

          <mj-input-group>
            <mj-input-label for="password">
              Passwort
            </mj-input-label>
            <mj-validation-input-field
              v-model="form.password"
              name="password"
              type="password"
              rules="required"
              @focus="clearError"
            />
          </mj-input-group>

          <div class="flex flex-col mt-8 xs:flex-row xs:flex-row-reverse xs:justify-between">
            <mj-button
              type="submit"
              class="mb-4 btn-primary xs:mb-0"
              :is-busy="isBusy"
              @click="onLogin"
            >
              Login
            </mj-button>
            <a
              target="_blank"
              href="https://moment-juke.de/passwort-vergessen"
            >
              <mj-button
                class="btn-naked -ml-4"
                type="button"
                v-text="'Passwort vergessen?'"
              />
            </a>
          </div>
          <div
            v-if="hasError"
            class="flex justify-end text-right"
          >
            <mj-inline-error
              style="max-width: 15rem;"
              :errors="errorMessage"
            />
          </div>
        </mj-validation-observer>
      </mj-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {

  data() {
    return {
      form: {
        email: null,
        password: null,
      },
      hasError: false,
      errorMessage: ['Oops, dein Login ist leider fehlgeschlagen, versuche es bitte erneut.'],
      isBusy: false,
    };
  },
  methods: {
    ...mapActions(['login']),
    onLogin() {
      this.clearError();
      this.isBusy = true;
      this.login(this.form)
        .then(data => {
          if (data.has_finished_wizard) {
            if (data.is_spotify_authorized) {
              this.$router.push({ name: 'event.overview' });
            } else {
              this.$router.push({ name: 'spotify.authorization' });
            }
          } else {
            this.$router.push({ name: 'configuration.wizard.first.things.first' });
          }
        })
        .catch(() => { this.hasError = true; })
        .finally(() => { this.isBusy = false; });
    },
    clearError() {
      if (this.hasError) {
        this.hasError = false;
      }
    },
  },
};
</script>
